<form>
  <!-- Modal Header -->
  <div class="modal-header">
    <h4 class="modal-title">Commission Request Message</h4>
    <button type="button" class="btn-close" data-dismiss="modal" tabindex="-1" (click)="reset()"></button>
  </div>

  <div class="modal-body">
    @if (sharedService.isAdmin() || sharedService.isBossAccount()) {
      <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label>Commission Message</mat-label>
            <input matInput name="message" [(ngModel)]="message" placeholder="Paste Commission Message" rows="1" style="user-select: all; white-space: pre" />
          </mat-form-field>
        </div>
        <div class="col align-items-center justify-content-start">
          <button class="btn btn-info" (click)="findLoanAndCompare()">Find</button>
        </div>
      </div>
    } @else if (sharedService.isBranchAccountHandler()) {
      <div class="row">
        <div class="col">
          <mat-form-field>
            <mat-label>Request Percentage (%)</mat-label>
            <input matInput name="requestPercentage" [(ngModel)]="requestPercentage" rows="1" (keypress)="sharedService.isNumberKey($event)" style="user-select: all; white-space: pre" />
          </mat-form-field>
        </div>
        <div class="col">
          <mat-form-field>
            <mat-label>Reason</mat-label>
            <input matInput name="reason" [(ngModel)]="reason" rows="1" style="user-select: all; white-space: pre" />
          </mat-form-field>
        </div>
        <div class="col align-items-center justify-content-end">
          <button class="btn btn-info" (click)="generateCommissionRequestMessage()">Generate Message</button>
        </div>
      </div>
    }
    @if (compareString !== "") {
      <h3 class="fw-bold">Compare Result:</h3>
    }
    @if (value != undefined) {
      <app-message-clipboard [compareString]="compareString" [value]="value"></app-message-clipboard>
    }

    @if (lgId != undefined && loan != undefined && (sharedService.isAdmin() || sharedService.isBossAccount())) {
      <app-override-comm-limit [isModal]="false" [loanGroupId]="lgId" [loan]="loan" [loanId]="loanId" [commLimit]="requestPercentage" [remark]="reason" [loanGroup]="loanGroup"></app-override-comm-limit>
    }
  </div>
</form>
